import {
  Identifiable,
  Resource,
  Project,
  ProjectResource,
  CostProfile,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

function saveCostProfileAssignation(httpClient: HttpClient) {
  return (
    costProfile: Identifiable<CostProfile>,
    resource: Identifiable<Resource>,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/resources/${resource.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        costProfile: `costProfiles/${costProfile.uuid}`,
      },
    });
}

export { saveCostProfileAssignation };
